import { useAuth } from "../contexts/AuthContext";

export const DashboardPage = () => {
  const { user } = useAuth();

  return (
    <div className="space-y-6">
      <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-6 border border-sky-200/50 shadow-lg">
        <h1 className="text-sky-900">
          Welcome back, {user?.name}!
        </h1>
        <p className="text-sky-600 mt-1">
          Here's what's happening with your operations today.
        </p>
      </div>
    </div>
  );
};
